import React from "react";
import ReactDOM from "react-dom/client"; // use react-dom/client for React 18+
import App from "./App";
import "./Styles.scss";
import { UserProvider } from "src/contexts/UserContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
     <UserProvider>
    <App />
    </UserProvider>
  </React.StrictMode>
);
